<template>
  <div class="pa-2">
    <Preloader v-if="loading"/>
    
    <div class="d-flex align-center justify-space-between mb-4" style="width: 100%">
      <div class="d-flex align-center" style="min-width: 0; flex-shrink: 1;">
        <v-icon left class="mr-2">mdi-signature</v-icon>
        <div class="text-h6 text-truncate">Signature Field</div>
      </div>
      <div class="d-flex align-center flex-shrink-0 ml-2">
        <v-btn small text dense @click="$emit('cancel')">Cancel</v-btn>
        <v-btn small color="info" @click="save" class="ml-2">Save</v-btn>
      </div>
    </div>

    <v-alert
      :value="true"
      type="warning"
      :outline="true"
      class="mb-4"
      dense
    >
      A signature is only collected when a client submits (when Sign on Submission is enabled) and when the status is changed to "Request Signature". Once a signature is requested, no changes should be made to the document as they will not be reflected in the signed document.
    </v-alert>

    <div class="text-subtitle-2 mb-2">Declaration Text</div>
    <div class="text-caption mb-2">Text to display for signature field. This is often a declaration or acknowledgement.</div>
    <Editor
      ref="htmlEditor"
      :html="editsignature.text"
    />

    <v-divider class="my-4" />

    <div class="text-subtitle-2 mb-2">Display Settings</div>
    <v-checkbox
      v-model="editsignature.pdf_only"
      label="PDF Only"
      persistent-hint
      hint="Do not show on Web"
      class="mt-0 mb-4"
    />

    <v-divider class="my-4" />

    <div class="text-subtitle-2 mb-2">Conditional Visibility</div>
    <v-checkbox
      v-model="conditional_part"
      label="Conditional Form Part"
      persistent-hint
      hint="Display part depending on answer to question"
      class="mt-0 mb-4"
    />
    
    <div v-if="conditional_part" class="pl-3" style="border-left: 2px solid #eee;">
      <v-text-field
        v-model="editsignature.conditional_question_id"
        label="Question ID"
        disabled
        class="mb-4"
      />
      <v-text-field
        v-model="editsignature.conditional_fieldtype_id"
        label="Fieldtype ID"
        disabled
        class="mb-4"
      />
      <v-text-field
        v-model="editsignature.conditional_value"
        label="Conditional Value"
        class="mb-4"
      />
      <v-checkbox
        v-model="editsignature.conditional_apply_pdf"
        label="Apply to PDF"
        persistent-hint
        hint="Hide from PDF if part fails condition"
        class="mt-0 mb-4"
      />
      <v-btn
        small
        outlined
        @click="fieldSelecting = true"
        class="mb-4"
      >
        Select A Field
      </v-btn>
    </div>

    <FormTemplateFieldSelector
      :templateID="$route.params.id"
      v-if="!loading && fieldSelecting"
      @select="fieldSelecting = false;editsignature.conditional_question_id = arguments[0].question_id; editsignature.conditional_fieldtype_id = arguments[0].fieldtype_id"
      @cancel="fieldSelecting = false"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Preloader from '@/components/global/Preloader'
import Editor from '@/components/admin/Editor'
import FormTemplateFieldSelector from '@/components/admin/FormTemplateFieldSelector'

export default {
  name: 'EsignatureProperties',
  props: [ 'partId', 'newPart' ],
  components: {
    Preloader,
    Editor,
    FormTemplateFieldSelector
  },
  data () {
    return {
      editsignature: {},
      loading: false,
      conditional_part: false,
      fieldSelecting: false,
      dialogVisible: true
    }
  },
  computed: {
    ...mapGetters('formtemplate', [
      'partById',
    ]),
    esignature () {
      return this.partById(this.partId) || this.newPart
    }
  },
  created () {
    this.editsignature = JSON.parse(JSON.stringify(this.esignature))
    this.conditional_part = (this.editsignature.conditional_question_id)
  },
  methods: {
    ...mapActions('formtemplate', [
      'saveEsignature'
    ]),
    save () {
      this.loading = true
      this.saveHTML()
      if(!this.conditional_part){
        this.editsignature.conditional_question_id = null
        this.editsignature.conditional_fieldtype_id = null
        this.editsignature.conditional_apply_pdf = false
        this.editsignature.conditional_value = ""
      }
      this.saveEsignature(this.editsignature)
      .then(signature => {
        this.$emit('save', signature)
        this.loading = false
      })
    },
    saveHTML () {
      this.editsignature.text = this.$refs.htmlEditor.getHTML()
    }
  }
}
</script>

<style scoped>
.editor__content .ProseMirror {
  min-height: 250px;
}
</style>
